export default {
  addOns: 'アドオン',
  all: 'すべて',
  browse: '閲覧',
  buyTickets: 'チケットを購入',
  countSelected: '{{count}}件選択中',
  joinWaitlist: 'ウェイトリストに参加',
  joining: '参加中',
  noDatesAvailable: '利用可能な日付がありません',
  salesEnded: '販売終了',
  schedule: 'スケジュール',
  seeMoreDates: 'もっと見る',
  soldOut: '売り切れ',
  about: '概要',
  agenda: 'アジェンダ',
  menu: 'メニュー',
  included: '含まれています',
  viewMore: 'もっと見る',
  viewLess: '少なく見る',
  location: '場所',
  time: '時間',
  at: 'で',
  noTimesAvailableOnThisDateFotThisPartySize:
    'この日付ではこの人数の利用可能な時間がありません',
  availableTimes: '利用可能な時間',
  waitlist: 'ウェイトリスト',
  continue: '続ける',
  tickets: 'チケット',
  ticketsAreNoLongerAvailable: 'チケットはもう利用できません。',
  checkOutOutOtherExperiences: '他の体験もご覧ください！',
  viewExperiences: '体験を見る',
  from: 'から',
  cancellationPolicy: 'キャンセルポリシー',
  rsvp: 'RSVP',
  nights: '夜',
  request: 'リクエスト',
  arrival: '到着',
  departure: '出発',
};
